// extracted by mini-css-extract-plugin
export var cardIcon = "_9s-5";
export var checkboxCard = "_9s-0";
export var checkboxCardSelected = "_9s-4";
export var disabled = "_9s-2";
export var interactive = "_9s-1";
export var outerBorder = "_9s-3";
export var spacerMedium = "_9s-8";
export var spacerSmall = "_9s-7";
export var spacerXsmall = "_9s-6";